import { QueryHookOptions, useLazyQuery } from '@apollo/client/react';

import AppModule from '@app/lib/AppModule';
import appManager from '@app/appManager';
import { getVoicemailsBadgeCountFilters } from '@pages/urgentfollowups/VoicemailsPage/utils/filters';
import {
  VoicemailFollowUpFilterInput,
  VoicemailsCountQuery,
  Exact,
  InputMaybe,
} from '@api/generated/graphql';
import { GET_VOICEMAIL_FOLLOW_UPS_COUNT_QUERY } from './data/count';

export type VoicemailsCountExecuteQueryOptions = QueryHookOptions<
  VoicemailsCountQuery,
  Exact<{
    filter?: InputMaybe<VoicemailFollowUpFilterInput>;
    take?: InputMaybe<number>;
  }>
>;

let executeQuery: (options?: VoicemailsCountExecuteQueryOptions) => void;

export function useVoicemailsCountQuery() {
  const [execute, queryResult] = useLazyQuery(
    GET_VOICEMAIL_FOLLOW_UPS_COUNT_QUERY,
    {
      fetchPolicy: 'network-only',
    },
  );

  executeQuery = execute;

  return {
    error: queryResult.error,
    previousCount: queryResult.previousData?.voicemailFollowUps?.totalCount,
    currentCount: queryResult.data?.voicemailFollowUps?.totalCount,
    execute: (options?: QueryHookOptions<VoicemailsCountQuery>) => {
      execute(options);
    },
  };
}

class VoicemailsModule extends AppModule {
  override events = ['voicemail.update'];

  override preload(): void {
    if (executeQuery === undefined) {
      this.app.logger.warn(
        'VoicemailsModule: executeQuery is undefined, ensure useVoicemailsCountQuery is called before this module is used.',
      );
    }
    this.app.events.on('voicemail.update', () => {
      this.app.logger.info('trigger voicemail badge refresh');
      executeQuery?.({
        variables: {
          filter: getVoicemailsBadgeCountFilters(),
          take: 1,
        },
      });
    });
  }
}

export default new VoicemailsModule(
  appManager.events,
  appManager.logger('Voicemails'),
);
